import React, { useRef } from 'react'
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { FieldWrapper } from '@progress/kendo-react-form';
import { Error, Hint } from '@progress/kendo-react-labels';
import LabelPure from '../../../pures/label/label.pure';

function BotTemplateDropdownWrapper(fieldRenderProps) {
    const {
        touched,
        label,
        id,
        valid,
        hint,
        validationMessage,
        data = [],
        placeholder,
        value,
        onChange,
        ...others
    } = fieldRenderProps;

    const editorRef = useRef(null);
    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : "";
    const errorId = showValidationMessage ? `${id}_error` : "";
    const labelId = label ? `${id}_label` : "";
    const selectedItem = data.find(item => item.id === value) || null;

    return (
        <FieldWrapper className={`botTemplateDropdownWrapper ${showValidationMessage ? "botTemplateDropdownWrapper-error" : ""}`}>
            <LabelPure
                id={labelId}
                editorId={id}
                className="k-form-label"
                title={label}
            />
            <div className={"k-form-field-wrap"}>
                <DropDownList
                    ariaLabelledBy={labelId}
                    ariaDescribedBy={`${hintId} ${errorId}`}
                    ref={editorRef}
                    id={id}
                    className="eticket-dropdown-field"
                    fillMode="flat"
                    rounded={false}
                    data={data}
                    textField="name"
                    dataItemKey="id"
                    defaultItem={{ id: null, name: placeholder }}
                    value={selectedItem}
                    onChange={(e) => onChange({ value: e.value?.id ?? null })}
                    validationMessage={validationMessage}
                    {...others}
                    valid={!showValidationMessage}
                />
                {showHint && <Hint id={hintId}>{hint}</Hint>}
                {showValidationMessage && (
                    <Error id={errorId}>{validationMessage}</Error>
                )}
            </div>
        </FieldWrapper>
    )
};

export default BotTemplateDropdownWrapper
